import { CusHttp } from './../../core/services/CusHttp';
import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';


@Component({
  selector: 'school-picker-item',
  templateUrl: './school-picker-item.component.html',
  styleUrls: ['./school-picker-item.component.scss']
})
export class SchoolPickerItemComponent implements OnInit {
  @Output() selected = new EventEmitter;
  constructor(
    private _http: CusHttp,
  ) { }

  ngOnInit() {
    const defaultProvinceId = 1;
    this.getColleges(defaultProvinceId);

    this._http.get('v1/district').then((res:any) => {
      this.provinces = res.data;
      this.selectedCity = this.provinces.find(rec => +rec.id === defaultProvinceId) || {};
    })
  }

  getColleges(id, kwd='') {
    return this._http.get(`v1/college?province_id=${id}&kw=${kwd}`).then((res:any) => {
      this.colleges = res.data;
    });
  }
  @Input() placeholder = '选择学校';
  visible = false;
  @Input() value = '';

  kw = '';

  colleges = [];
  selectedCity:any = {};
  provinces:any[] = [];

  cities = [];

  handlerClickInput() {
    this.visible = true;
  }

  provinceChange(e) {
    console.log(e);
  }

  search() {
    this.getColleges(this.selectedCity.id, this.kw)
  }

  selectItem(item, e) {
    e.stopPropagation();
    this.value = item.name
    this.visible = false;
    this.selected.emit(this.value);
  }
}






// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/school-picker-item/school-picker-item.component.ts